/** @jsx jsx */
import PropTypes from 'prop-types';
import { jsx, css, } from '@emotion/core';
import styled from '@emotion/styled';
import { LayoutContext, ColContext, } from './grid-context';
import Grid from './grid';
import Spacing from './spacing';

const StyledContainer = styled.section((props:any,) => {
  const { fullBleed, withPadding } = props;

  return (css`
    ${Grid.grid}
    ${Grid.close}

    ${fullBleed ? `
        padding: ${withPadding ? Spacing.Close : 0} ${withPadding ? Spacing.Large : 0};
      ` : 'margin: 0 10px;'
    }

    @media only screen and (-ms-high-contrast: none) {
      flex-direction: column;

      > div:last-child {
        margin-bottom: 0;
      }
    }

    > p {
      margin: 0;
    }
  `);
},);

const Container = (props:any,) => (
  <LayoutContext.Consumer>
    {(layout,) => (
      <ColContext.Consumer>
        {(column,) => (
          <StyledContainer layout={layout} column={column} {...props} />
        )}
      </ColContext.Consumer>
    )}
  </LayoutContext.Consumer>
);

Container.displayName = 'Container';

Container.propTypes = {
  children: PropTypes.node,
  fullBleed: PropTypes.bool,
  color: PropTypes.string,
};

Container.defaultProps = {
  withPadding: false,
  fullBleed: false,
  color: '#DDD',
};

export default Container;
